import { http } from "./http";

/** Certificat de scolarité délivré (informations figées à la délivrance). */
export interface Certificate {
  id: string;
  /** « CERT-2026-0001 » */
  number: string;
  enrollmentId: string | null;
  studentId: string;
  schoolYear: string;
  matricule: string;
  studentName: string;
  gender: "M" | "F" | null;
  birthDate: string | null;
  birthPlace: string | null;
  className: string;
  signatoryName: string | null;
  signatoryTitle: string | null;
  issuedByName: string;
  /** Date de délivrance (ISO). */
  createdAt: string;
}

interface ApiCertificate extends Omit<Certificate, "id" | "enrollmentId" | "studentId"> {
  id: number;
  enrollmentId: number | null;
  studentId: number;
}

const toCertificate = (c: ApiCertificate): Certificate => ({
  ...c,
  id: String(c.id),
  enrollmentId: c.enrollmentId === null ? null : String(c.enrollmentId),
  studentId: String(c.studentId),
});

/** Délivre un nouveau certificat numéroté pour une inscription. */
export async function issueCertificate(enrollmentId: string): Promise<Certificate> {
  return toCertificate(await http.post<ApiCertificate>("/certificates", { enrollmentId: Number(enrollmentId) }));
}

/** Certificats déjà délivrés à un élève (le plus récent d'abord). */
export async function listCertificates(studentId: string): Promise<Certificate[]> {
  return (await http.get<ApiCertificate[]>("/certificates", { studentId })).map(toCertificate);
}
